import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sControllerEndpoint = 'UserRole';
const sActionEndPoint = 'login';

export class UserRoleAPI {

	requestUserRoles() {
		return axios.get(getBackendURL() + sControllerEndpoint);
	}

	logout(sUsername = '') {
		return axios.delete(getBackendURL() + sActionEndPoint, { data: { username: sUsername } }, {
			headers: {
				'Content-Type': 'application/json',
			}
		});
	}

	//Logs into the application
	//Send parametes at request body
	requestAuthorizationCookie(sUsername, sPassword) {
		let params = JSON.stringify({
			username: sUsername,
			password: sPassword
		})
		return axios.post(getBackendURL() + sActionEndPoint, params, {
			headers: {
				'Content-Type': 'application/json',
			}
		})
	}

    checkUserLogin(sUsername) {
		return axios.post(getBackendURL() + sActionEndPoint + "/CheckUserLogin", { username: sUsername }, {
			headers: {
				'Content-Type': 'application/json',
			}
		});
	}

}

export default UserRoleAPI


// WEBPACK FOOTER //
// ./src/API/UserRoleAPI.js